import { Gift } from "lucide-react";
import { formatIDR } from "@kanata/shared";
import type { PublicPromo } from "@/lib/api";
import { promoEndsLabel } from "@/lib/promo";

/**
 * On a desk's product page: what buying it here comes with while the
 * promotion is live. Divine's framing: buying on the website gets you the
 * fuller package. It is said beside the price, before the customer adds it
 * to the cart, where the cart then shows the same things at Rp 0.
 */
export function PromoNote({ promo, className }: { promo: PublicPromo; className?: string }) {
  const ends = promoEndsLabel(promo.endsAt);
  const items: { label: string; was?: number }[] = [];
  if (promo.gift) items.push({ label: `${promo.gift.productName} gratis`, was: promo.gift.priceIdr });
  if (promo.packingKayuPriceIdr) items.push({ label: "Packing kayu gratis", was: promo.packingKayuPriceIdr });
  if (promo.shippingSubsidyMaxIdr > 0) items.push({ label: `Subsidi ongkir s/d ${formatIDR(promo.shippingSubsidyMaxIdr)}` });
  if (items.length === 0) return null;

  return (
    <div className={`rounded-xl border border-brand/25 bg-brand-light/40 px-4 py-3 text-sm ${className ?? ""}`}>
      <p className="flex items-center gap-2 font-medium text-brand-dark">
        <Gift className="size-4 shrink-0" />
        Termasuk {promo.name}
      </p>
      <ul className="mt-2 space-y-1 text-ink/75">
        {items.map((i) => (
          <li key={i.label} className="flex justify-between gap-3">
            <span>{i.label}</span>
            {i.was !== undefined && (
              <del className="shrink-0 text-xs tabular-nums text-ink/45">{formatIDR(i.was)}</del>
            )}
          </li>
        ))}
      </ul>
      <p className="mt-2 text-xs text-ink/55">
        Otomatis di keranjang, tanpa kode{ends ? `. Berlaku sampai ${ends}` : ""}.
      </p>
    </div>
  );
}
